export default __webpack_public_path__ + "static/media/SM.0bfea682.svg";